module.exports = __webpack_public_path__ + "static/ROLVEDON-Logo-9f1562a8754f289eee4d80c4eddc936d.png";